<template>
  <navbar
    position="fixed"
    type="custom"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
    class="custom-navbar"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        <img class="navbar-logo" src="/Wegweiser.svg">
        mathias moeller
      </router-link>
    </template>
    <template slot="navbar-menu" slot-scope="{ close }">
      <li class="nav-item">
        <nav-link class="nav-link" to="/gallery">
          Gallery
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link class="nav-link" to="/about" @click="close()">
          About
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link class="nav-link" to="/buy">
          Buy
        </nav-link>
      </li>
    </template>
  </navbar>
</template>

<script>
  import { Navbar, NavLink } from '@/components';

  export default {
    name: 'main-navbar',
    props: {
      colorOnScroll: Number,
    },
    components: {
      Navbar,
      NavLink,
    },
  };
</script>

<style lang="scss" scoped>
</style>
